export default __webpack_public_path__ + "home1.jpg";